import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Login',
            component: r => require.ensure([], () => r(require('../components/login')), 'Login')
        },
        {
          path: '/downImg',
          name: 'downImg',
          component: r => require.ensure([], () => r(require('../components/downImg')), 'downImg')
        },
        {
          path: '/excel',
          name: 'excel',
          component: r => require.ensure([], () => r(require('../components/lookExcel')), 'lookExcel')
        },
        {
          path: '/lookExcel',
          name: 'excel1',
          component: r => require.ensure([], () => r(require('../components/lookExcel1')), 'lookExcel')
        },
        {
            path: '/home',
            name: 'Home',
            component: r => require.ensure([], () => r(require('../components/home')), 'Home'),
            children: [{
                    path: '/home/productList',
                    name: 'ProductList',
                    component: r => require.ensure([], () => r(require('../components/productList')), 'ProductList'),
                },
                {
                    path: '/home/dashboard',
                    name: 'Dashboard',
                    component: r => require.ensure([], () => r(require('../components/dashboard')), 'Dashboard'),
                },
                {
                    path: '/home/accountList',
                    name: 'AccountList',
                    component: r => require.ensure([], () => r(require('../components/accountList')), 'AccountList'),
                },
                {
                    path: '/home/optionDetail',
                    name: 'OptionDetail',
                    component: r => require.ensure([], () => r(require('../components/optionDetail')), 'OptionDetail'),
                },
                {
                    path: '/home/appList',
                    name: 'AppList',
                    component: r => require.ensure([], () => r(require('../components/appList')), 'AppList'),
                },
                {
                    path: '/home/appConfig',
                    name: 'AppConfig',
                    component: r => require.ensure([], () => r(require('../components/appConfig')), 'AppConfig'),
                },
                {
                    path: '/home/antdiyData',
                    name: 'AntdiyData',
                    component: r => require.ensure([], () => r(require('../components/antdiyData')), 'AntdiyData'),
                },
                {
                    path: '/home/antdiyOverview',
                    name: 'AntdiyOverview',
                    component: r => require.ensure([], () => r(require('../components/antdiyOverview')), 'AntdiyOverview'),
                },
                {
                    path: '/home/antdiyDashboard',
                    name: 'AntdiyDashboard',
                    component: r => require.ensure([], () => r(require('../components/antdiyDashboard')), 'AntdiyDashboard'),
                },
                {
                    path: '/home/shopifyProduct',
                    name: 'ShopifyProduct',
                    component: r => require.ensure([], () => r(require('../components/shopifyProduct')), 'ShopifyProduct'),
                },
                {
                    path: '/home/fbaccredit',
                    name: 'fbaccredit',
                    component: r => require.ensure([], () => r(require('../components/antdiy/fbaccredit')), 'fbaccredit'),
                },
                {
                    path: '/home/fbautomatic',
                    name: 'fbautomatic',
                    component: r => require.ensure([], () => r(require('../components/antdiy/fbautomatic')), 'fbautomatic'),
                },
                {
                    path: '/home/antnestSet',
                    name: 'AntnestSet',
                    component: r => require.ensure([], () => r(require('../components/antnestSet')), 'AntnestSet'),
                },
                {
                    path: '/home/userMange',
                    name: 'UserMange',
                    component: r => require.ensure([], () => r(require('../components/antdiy/userMange.vue')), 'UserMange'),
                    meta: {
                        keepAlive: true // 需要缓存
                    }
                },
                {
                    path: '/home/productMange',
                    name: 'ProductMange',
                    component: r => require.ensure([], () => r(require('../components/antdiy/productMange.vue')), 'ProductMange'),
                },
                {
                    path: '/home/orderMange',
                    name: 'OrderMange',
                    component: r => require.ensure([], () => r(require('../components/antdiy/orderMange.vue')), 'OrderMange'),
                },
                {
                  path: '/home/orderDetails',
                  name: 'orderDetails',
                  component: r => require.ensure([], () => r(require('../components/antdiy/orderDetails.vue')), 'orderDetails'),
                },
                {
                    path: '/home/storeMange',
                    name: 'StoreMange',
                    component: r => require.ensure([], () => r(require('../components/antdiy/storeMange.vue')), 'StoreMange'),
                },
                {
                    path: '/home/userDetail',
                    name: 'UserDetail',
                    component: r => require.ensure([], () => r(require('../components/antdiy/userDetail.vue')), 'UserDetail'),
                },
                {
                    path: '/home/productDetail',
                    name: 'ProductDetail',
                    component: r => require.ensure([], () => r(require('../components/antdiy/productDetail.vue')), 'ProductDetail'),
                },
                {
                    path: '/home/orderDetail',
                    name: 'OrderDetail',
                    component: r => require.ensure([], () => r(require('../components/antdiy/orderDetail.vue')), 'OrderDetail'),
                },
                {
                    path: '/home/work',
                    name: 'work',
                    component: r => require.ensure([], () => r(require('../components/work.vue')), 'work'),
                    meta: {
                        keepAlive: true // 需要缓存
                    }
                },
                {
                    path: '/home/searchOrder',
                    name: 'searchOrder',
                    component: r => require.ensure([], () => r(require('../components/searchOrder.vue')), 'searchOrder'),
                },
                {
                    path: '/home/sellData',
                    name: 'sellData',
                    component: r => require.ensure([], () => r(require('../components/sellData.vue')), 'sellData'),
                },
                {
                    path: '/home/workDetail',
                    name: 'workDetail',
                    component: r => require.ensure([], () => r(require('../components/workDetail.vue')), 'workDetail'),
                },
                {
                    path: '/home/workOrder',
                    name: 'workOrder',
                    component: r => require.ensure([], () => r(require('../components/workOrder.vue')), 'workOrder'),
                },
                {
                    path: '/home/globalLogistics',
                    name: 'globalLogistics',
                    component: r => require.ensure([], () => r(require('../components/work_order/globalLogistics.vue')), 'globalLogistics'),
                },
                {
                    path: '/home/order1688',
                    name: 'order1688',
                    component: r => require.ensure([], () => r(require('../components/1688order.vue')), 'Order1688'),
                },
                {
                    path: '/home/shopifyOrder',
                    name: 'shopifyOrder',
                    component: r => require.ensure([], () => r(require('../components/shopifyOrder.vue')), 'shopifyOrder'),
                },
                {
                    path: '/home/orderData',
                    name: 'orderData',
                    component: r => require.ensure([], () => r(require('../components/orderData.vue')), 'orderData'),
                },
                {
                    path: '/home/capital',
                    name: 'capital',
                    component: r => require.ensure([], () => r(require('../components/capital.vue')), 'capital'),
                },
                {
                    path: '/home/bankrollMana',
                    name: 'bankrollMana',
                    component: r => require.ensure([], () => r(require('../components/bankrollMana/bankrollMana.vue')), 'bankrollMana'),
                },
                {
                    path: '/home/capitalDetail',
                    name: 'capitalDetail',
                    component: r => require.ensure([], () => r(require('../components/bankrollMana/capitalDetail.vue')), 'capitalDetail'),
                },
                {
                    path: '/home/fundsMana',
                    name: 'fundsMana',
                    component: r => require.ensure([], () => r(require('../components/bankrollMana/fundsMana.vue')), 'fundsMana'),
                },
                {
                    path: '/home/fundsRecord',
                    name: 'fundsRecord',
                    component: r => require.ensure([], () => r(require('../components/bankrollMana/fundsRecord.vue')), 'fundsRecord'),
                },
                {
                    path: '/home/internalReconciliation',
                    name: 'internalReconciliation',
                    component: r => require.ensure([], () => r(require('../components/bankrollMana/InternalReconciliation.vue')), 'internalReconciliation'),
                },

                {
                    path: '/home/tradingRecord',
                    name: 'tradingRecord',
                    component: r => require.ensure([], () => r(require('../components/bankrollMana/tradingRecord.vue')), 'tradingRecord'),
                },
                {
                    path: '/home/workPurchase',
                    name: 'workPurchase',
                    component: r => require.ensure([], () => r(require('../components/workPurchase.vue')), 'workPurchase'),
                    meta: {
                        keepAlive: true // 需要缓存
                    }
                },
                {
                    path: '/home/internationLogistics',
                    name: 'internationLogistics',
                    component: r => require.ensure([], () => r(require('../components/work_order/internationLogistics.vue')), 'internationLogistics'),
                    meta: {
                        keepAlive: true // 需要缓存
                    }
                },
                {
                    path: '/home/premiumWorkOrder',
                    name: 'premiumWorkOrder',
                    component: r => require.ensure([], () => r(require('../components/work_order/premiumWorkOrder.vue')), 'premiumWorkOrder'),
                    meta: {
                        keepAlive: true // 需要缓存
                    }
                },
                {
                    path: '/home/internationDetail',
                    name: 'internationDetail',
                    component: r => require.ensure([], () => r(require('../components/work_order/internationDetail.vue')), 'internationDetail')
                },

                {
                    path: '/home/orderPurchase',
                    name: 'orderPurchase',
                    component: r => require.ensure([], () => r(require('../components/orderPurchase.vue')), 'orderPurchase'),
                },
                {
                    path: '/home/workCapital',
                    name: 'WorkCapital',
                    component: r => require.ensure([], () => r(require('../components/workCapital.vue')), 'WorkCapital'),
                    meta: {
                        keepAlive: true // 需要缓存
                    }
                },
                {
                    path: '/home/rechargeAudit',
                    name: 'RechargeAudit',
                    component: r => require.ensure([], () => r(require('../components/rechargeAudit.vue')), 'RechargeAudit'),
                },

                {
                    path: '/home/autoAdInfo',
                    name: 'autoAdInfo',
                    component: r => require.ensure([], () => r(require('../components/autoAdInfo.vue')), 'autoAdInfo'),
                },
                {
                    path: '/home/adminWork',
                    name: 'adminWork',
                    component: r => require.ensure([], () => r(require('../components/adminWork.vue')), 'adminWork'),
                },
                {
                    path: '/home/recommended',
                    name: 'recommended',
                    component: r => require.ensure([], () => r(require('../components/recommended.vue')), 'recommended'),
                },
                {
                    path: '/home/project',
                    name: 'womens',
                    component: r => require.ensure([], () => r(require('../components/project/projectIndex.vue')), 'project'),
                },
                {
                    path: '/home/upload',
                    name: 'upload',
                    component: r => require.ensure([], () => r(require('../components/upload.vue')), 'upload'),
                },
                {
                    path: '/home/records',
                    name: 'records',
                    component: r => require.ensure([], () => r(require('../components/capital/records.vue')), 'records'),
                },
                {
                    path: '/home/user',
                    name: 'user',
                    component: r => require.ensure([], () => r(require('../components/user/user.vue')), 'user'),
                },
                {
                    path: '/home/power',
                    name: 'power',
                    component: r => require.ensure([], () => r(require('../components/allPower/user.vue')), 'power'),
                },
                {
                    path: '/home/reconciliation',
                    name: 'reconciliation',
                    component: r => require.ensure([], () => r(require('../components/capital/reconciliation.vue')), 'reconciliation'),
                },
                {
                    path: '/home/supplyOrderDetail',
                    name: 'supplyOrderDetail',
                    component: r => require.ensure([], () => r(require('../components/supplyOrderDetail.vue')), 'supplyOrderDetail'),
                },
                {
                    path: '/home/allWorkOrder',
                    name: 'allWorkOrder',
                    component: r => require.ensure([], () => r(require('../components/allWorkOrder.vue')), 'allWorkOrder'),
                },
                {
                    path: '/home/closeWork',
                    name: 'closeWork',
                    component: r => require.ensure([], () => r(require('../components/closeWork.vue')), 'closeWork'),
                },
                {
                    path: '/home/closeDetail',
                    name: 'closeDetail',
                    component: r => require.ensure([], () => r(require('../components/closeDetail.vue')), 'closeDetail'),
                },
                {
                    path: '/home/refund',
                    name: 'refund',
                    component: r => require.ensure([], () => r(require('../components/refund.vue')), 'refund'),
                },
                {
                    path: '/home/refundTop',
                    name: 'refundTop',
                    component: r => require.ensure([], () => r(require('../components/refundTop.vue')), 'refundTop'),
                },
                {
                    path: '/home/claims',
                    name: 'claims',
                    component: r => require.ensure([], () => r(require('../components/claims.vue')), 'claims'),
                },
                {
                    path: '/home/work_order/refundTopDetail',
                    name: 'refundTopDetail',
                    component: r => require.ensure([], () => r(require('../components/work_order/refundTopDetail.vue')), 'refundTopDetail'),
                },
                {
                    path: '/home/work_order/refundDetail',
                    name: 'refundDetail',
                    component: r => require.ensure([], () => r(require('../components/work_order/refundDetail.vue')), 'refundDetail'),
                },
                {
                    path: '/home/work_order/claimsDetail',
                    name: 'claimsDetail',
                    component: r => require.ensure([], () => r(require('../components/work_order/claimsDetail.vue')), 'claimsDetail'),
                },

        {
            path: '/home/unsubscribe',
            name: 'Unsubscribe',
            component: r => require.ensure([], () => r(require('../components/unsubscribe.vue')), 'unsubscribe'),
        },
        {
            path: '/home/capitalAdjustment',
            name: 'capitalAdjustment',
            component: r => require.ensure([], () => r(require('../components/capital/capitalAdjustment.vue')), 'capitalAdjustment'),
        },
        {
            path: '/home/clothes',
            name: 'clothes',
            component: r => require.ensure([], () => r(require('../components/antdiy/clothes.vue')), 'clothes'),
        },
        {
            path: '/home/orderNumDetail',
            name: 'orderNumDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/orderNumDetail.vue')), 'orderNumDetail'),
        },
        {
            path: '/home/pushNumDetail',
            name: 'pushNumDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/pushNumDetail.vue')), 'pushNumDetail'),
        },
        {
            path: '/home/itemList',
            name: 'itemList',
            component: r => require.ensure([], () => r(require('../components/codSource/codItemList.vue')), 'itemList'),
        }, {
            path: '/home/spuList',
            name: 'spuList',
            component: r => require.ensure([], () => r(require('../components/codSource/codSpuList.vue')), 'spuList'),
        }, {
            path: '/home/newSpu',
            name: 'newSpu',
            component: r => require.ensure([], () => r(require('../components/codSource/codNewSpu.vue')), 'newSpu'),
        },
        {
            path: '/home/supplier',
            name: 'supplier',
            component: r => require.ensure([], () => r(require('../components/antsrm/supplier.vue')), 'supplier'),
        },
        {
            path: '/home/srmDasboard',
            name: 'srmDasboard',
            component: r => require.ensure([], () => r(require('../components/antsrm/srmDasboard.vue')), 'srmDasboard'),
        },
        {
            path: '/home/srmProducts',
            name: 'srmProducts',
            component: r => require.ensure([], () => r(require('../components/antsrm/srmProducts.vue')), 'srmProducts'),
        },
        {
            path: '/home/accountWork',
            name: 'accountWork',
            component: r => require.ensure([], () => r(require('../components/work_order/accountWork.vue')), 'accountWork'),
        },
        {
            path: '/home/accountWorkDetail',
            name: 'accountWorkDetail',
            component: r => require.ensure([], () => r(require('../components/work_order/accountWorkDetail.vue')), 'accountWorkDetail'),
        },
        {
            path: '/home/special',
            name: 'special',
            component: r => require.ensure([], () => r(require('../components/antsrm/special.vue')), 'special'),
        },
        {
            path: '/home/chainSpecial',
            name: 'chainSpecial',
            component: r => require.ensure([], () => r(require('../components/project/chainSpecial.vue')), 'chainSpecial'),
        },
        {
            path: '/home/goodsLibrary',
            name: 'goodsLibrary',
            component: r => require.ensure([], () => r(require('../components/project/goodsLibrary.vue')), 'goodsLibrary'),
        },
        {
            path: '/home/applyApp',
            name: 'applyApp',
            component: r => require.ensure([], () => r(require('../components/antdiy/applyApp.vue')), 'applyApp'),
        },
        {
            path: '/home/updataApp',
            name: 'updataApp',
            component: r => require.ensure([], () => r(require('../components/antdiy/updataApp.vue')), 'updataApp'),
        },
        {
            path: '/home/integral',
            name: 'integral',
            component: r => require.ensure([], () => r(require('../components/antdiy/integral.vue')), 'integral'),
        },
        {
            path: '/home/integralDetail',
            name: 'integralDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/integralDetail.vue')), 'integralDetail'),
        },
        {
            path: '/home/merchants',
            name: 'merchants',
            component: r => require.ensure([], () => r(require('../components/merchants.vue')), 'merchants'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/merchantsDetail',
            name: 'merchantsDetail',
            component: r => require.ensure([], () => r(require('../components/merchantsDetail.vue')), 'merchantsDetail'),
        },
        {
            path: '/home/projectItem',
            name: 'projectItem',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectItem.vue')), 'productPage'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/projectPublicItem',
            name: 'projectPublicItem',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectPublicItem.vue')), 'productPage'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/projectMaterialItem',
            name: 'projectMaterialItem',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectMaterialItem.vue')), 'productPage'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/projectSupplierItem',
            name: 'projectSupplierItem',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectSupplierItem.vue')), 'productPage'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/projectCommodity',
            name: 'projectCommodity',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectCommodity.vue')), 'projectCommodity'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/projectServiceItem',
            name: 'projectServiceItem',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectServiceItem.vue')), 'productPage'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/projectBigData',
            name: 'projectBigData',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectBigData.vue')), 'projectBigData'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/orderItem',
            name: 'orderItem',
            component: r => require.ensure([], () => r(require('../components/itemcenter/orderItem.vue')), 'productPage'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/categoryMana',
            name: 'categoryMana',
            component: r => require.ensure([], () => r(require('../components/itemcenter/categoryMana.vue')), 'categoryMana'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/productPage',
            name: 'productPage',
            component: r => require.ensure([], () => r(require('../components/itemcenter/productPage.vue')), 'productPage'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/productService',
            name: 'productService',
            component: r => require.ensure([], () => r(require('../components/itemcenter/productService.vue')), 'productService'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/productPageDetail',
            name: 'productPageDetail',
            component: r => require.ensure([], () => r(require('../components/itemcenter/productPageDetail.vue')), 'productPage'),
        },
        {
            path: '/home/projectLook',
            name: 'projectLook',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectLook.vue')), 'projectLook'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/projectPublicLook',
            name: 'projectPublicLook',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectPublicLook.vue')), 'projectPublicLook'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/projectMaterialLook',
            name: 'projectMaterialLook',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectMaterialLook.vue')), 'projectMaterialLook'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/projectServiceLook',
            name: 'projectServiceLook',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectServiceLook.vue')), 'projectServiceLook'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/projectSetting',
            name: 'projectSetting',
            component: r => require.ensure([], () => r(require('../components/itemcenter/projectSetting.vue')), 'productPage'),
        },
        {
            path: '/home/productSetting',
            name: 'productSetting',
            component: r => require.ensure([], () => r(require('../components/itemcenter/productSetting.vue')), 'productPage'),
        },
        {
            path: '/home/orderItemDetail',
            name: 'orderItemDetail',
            component: r => require.ensure([], () => r(require('../components/itemcenter/orderItemDetail.vue')), 'productPage'),
        },
        {
            path: '/home/editProuct',
            name: 'editProuct',
            component: r => require.ensure([], () => r(require('../components/itemcenter/editProuct.vue')), 'projectLook'),
        },
        {
            path: '/home/editService',
            name: 'editService',
            component: r => require.ensure([], () => r(require('../components/itemcenter/editService.vue')), 'projectLook'),
        },
        {
            path: '/home/editProuctSupplier',
            name: 'editProuctSupplier',
            component: r => require.ensure([], () => r(require('../components/itemcenter/editProuctSupplier.vue')), 'projectLook'),
        },
        {
            path: '/home/editProuctMaterial',
            name: 'editProuctMaterial',
            component: r => require.ensure([], () => r(require('../components/itemcenter/editProuctMaterial.vue')), 'projectLook'),
        },
        {
            path: '/home/loginRecord',
            name: 'loginRecord',
            component: r => require.ensure([], () => r(require('../components/loginRecord.vue')), 'loginRecord'),
        },
        {
            path: '/home/installRecord',
            name: 'installRecord',
            component: r => require.ensure([], () => r(require('../components/antdiy/installRecord.vue')), 'installRecord'),
        },
        {
            path: '/home/uninstallRecord',
            name: 'uninstallRecord',
            component: r => require.ensure([], () => r(require('../components/antdiy/uninstallRecord.vue')), 'uninstallRecord'),
        },
        {
            path: '/home/wholesale',
            name: 'wholesale',
            component: r => require.ensure([], () => r(require('../components/work_order/wholesale.vue')), 'wholesale'),
        },
        {
            path: '/home/sourcing',
            name: 'sourcing',
            component: r => require.ensure([], () => r(require('../components/antdiy/sourcing.vue')), 'sourcing'),
        },
        {
            path: '/home/sourcingDetail',
            name: 'sourcingDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/sourcingDetail.vue')), 'sourcingDetail'),
        },
        {
            path: '/home/sourcingDetailFinder',
            name: 'sourcingDetailFinder',
            component: r => require.ensure([], () => r(require('../components/antdiy/sourcingDetailFinder.vue')), 'sourcingDetailFinder'),
        },
        {
            path: '/home/registerRecord',
            name: 'registerRecord',
            component: r => require.ensure([], () => r(require('../components/antdiy/registerRecord.vue')), 'registerRecord'),
        },
        {
            path: '/home/bindRecord',
            name: 'bindRecord',
            component: r => require.ensure([], () => r(require('../components/antdiy/bindRecord.vue')), 'bindRecord'),
        },
        {
            path: '/home/loginRecord2',
            name: 'loginRecord2',
            component: r => require.ensure([], () => r(require('../components/antdiy/loginRecord2.vue')), 'loginRecord2'),
        },
        {
            path: '/home/uninstallRecord2',
            name: 'uninstallRecord2',
            component: r => require.ensure([], () => r(require('../components/antdiy/uninstallRecord2.vue')), 'uninstallRecord2'),
        },
        {
            path: '/home/orderRecord',
            name: 'orderRecord',
            component: r => require.ensure([], () => r(require('../components/antdiy/orderRecord.vue')), 'orderRecord'),
        },
        {
            path: '/home/changerecord',
            name: 'changerecord',
            component: r => require.ensure([], () => r(require('../components/antdiy/changerecord.vue')), 'changerecord'),
        },
        {
            path: '/home/countsearch',
            name: 'countsearch',
            component: r => require.ensure([], () => r(require('../components/antdiy/countsearch.vue')), 'countsearch'),
        },
        {
            path: '/home/ordercontent',
            name: 'ordercontent',
            component: r => require.ensure([], () => r(require('../components/ordercontent.vue')), 'ordercontent'),
        },
        {
            path: '/home/editionorder',
            name: 'editionorder',
            component: r => require.ensure([], () => r(require('../components/antdiy/editionorder.vue')), 'editionorder'),
        },
        {
            path: '/home/versionplan',
            name: 'versionplan',
            component: r => require.ensure([], () => r(require('../components/antdiy/versionplan.vue')), 'versionplan'),
        },
        {
            path: '/home/versionplanAdd',
            name: 'versionplanAdd',
            component: r => require.ensure([], () => r(require('../components/antdiy/versionplanAdd.vue')), 'versionplanAdd'),
        },
        {
            path: '/home/versionList',
            name: 'versionList',
            component: r => require.ensure([], () => r(require('../components/antdiy/versionList.vue')), 'versionList'),
        },
        {
            path: '/home/versionPlanList',
            name: 'versionPlanList',
            component: r => require.ensure([], () => r(require('../components/antdiy/versionPlanList.vue')), 'versionPlanList'),
        },
        {
            path: '/home/plansList',
            name: 'plansList',
            component: r => require.ensure([], () => r(require('../components/antdiy/plansList.vue')), 'plansList'),
        },
        {
            path: '/home/decrease',
            name: 'decrease',
            component: r => require.ensure([], () => r(require('../components/antdiy/decrease.vue')), 'decrease'),
        },
        {
            path: '/home/ordertable',
            name: 'ordertable',
            component: r => require.ensure([], () => r(require('../components/antdiy/ordertable.vue')), 'ordertable'),
        },
        {
            path: '/home/warehouse',
            name: 'warehouse',
            component: r => require.ensure([], () => r(require('../components/warehouse/warehouse.vue')), 'user'),
        },
        {
            path: '/home/contraband',
            name: 'contraband',
            component: r => require.ensure([], () => r(require('../components/contraband.vue')), 'contraband'),
        },
        {
            path: '/home/logisticsQuery',
            name: 'logisticsQuery',
            component: r => require.ensure([], () => r(require('../components/tms/logisticsQuery.vue')), 'logisticsQuery'),
        },
        {
            path: '/home/logisticsOrder',
            name: 'logisticsOrder',
            component: r => require.ensure([], () => r(require('../components/tms/logisticsOrder.vue')), 'logisticsOrder'),
        },
        {
            path: '/home/logisticsExpense',
            name: 'logisticsExpense',
            component: r => require.ensure([], () => r(require('../components/tms/logisticsExpense.vue')), 'logisticsExpense'),
        },
        // {
        //     path: '/home/businessAnalysis',
        //     name: 'businessAnalysis',
        //     component: r => require.ensure([], () => r(require('../components/tms/businessAnalysis.vue')), 'businessAnalysis'),
        // },
        {
            path: '/home/orderType',
            name: 'orderType',
            component: r => require.ensure([], () => r(require('../components/tms/orderType.vue')), 'orderType'),
        },
        {
            path: '/home/BusinessAnalysisDashboard',
            name: 'BusinessAnalysisDashboard',
            component: r => require.ensure([], () => r(require('../components/tms/OrderStageAnalysis.vue')), 'OrderStageAnalysis'),
        },
        {
            path: '/home/orderStatusGoods',
            name: 'orderStatusGoods',
            component: r => require.ensure([], () => r(require('../components/tms/orderStatusGoods.vue')), 'orderStatusGoods'),
        },
        {
            path: '/home/cashFlow',
            name: 'cashFlow',
            component: r => require.ensure([], () => r(require('../components/tms/cashFlow.vue')), 'cashFlow'),
        },
        {
            path: '/home/infoCashFlow',
            name: 'infoCashFlow',
            component: r => require.ensure([], () => r(require('../components/tms/infoCashFlow.vue')), 'infoCashFlow'),
        },
        {
            path: '/home/additionalInfo',
            name: 'additionalInfo',
            component: r => require.ensure([], () => r(require('../components/tms/additionalInfo.vue')), 'additionalInfo'),
        },
        {
            path: '/home/logisticsManage',
            name: 'logisticsManage',
            component: r => require.ensure([], () => r(require('../components/tms/logisticsManage.vue')), 'logisticsManage'),
        },
        {
            path: '/home/orderSummary',
            name: 'orderSummary',
            component: r => require.ensure([], () => r(require('../components/tms/orderSummary.vue')), 'orderSummary'),
        },
        {
            path: '/home/antdiyWarehouse',
            name: 'antdiyWarehouse',
            component: r => require.ensure([], () => r(require('../components/antdiy/antdiyWarehouse.vue')), 'antdiyWarehouse'),
        },
        {
          path: '/home/antshop',
          name: 'antshop',
          component: r => require.ensure([], () => r(require('../components/antdiy/antshop.vue')), 'antdiyWarehantshopouse'),
        },
        {
          path: '/home/orderAppeal',
          name: 'orderAppeal',
          component: r => require.ensure([], () => r(require('../components/antdiy/orderAppeal.vue')), 'orderAppeal'),
        },
        {
          path: '/home/quote',
          name: 'quote',
          component: r => require.ensure([], () => r(require('../components/antdiy/quote.vue')), 'quote'),
        },
        {
            path: '/home/performanceWorkOrder',
            name: 'performanceWorkOrder',
            component: r => require.ensure([], () => r(require('../components/antdiy/performanceWorkOrder.vue')), 'performanceWorkOrder'),
        },
        {
            path: '/home/serviceWorkOrder',
            name: 'serviceWorkOrder',
            component: r => require.ensure([], () => r(require('../components/antdiy/serviceWorkOrder.vue')), 'serviceWorkOrder'),
        },
        {
            path: '/home/oneForDelivery',
            name: 'oneForDelivery',
            component: r => require.ensure([], () => r(require('../components/antdiy/oneForDelivery.vue')), 'oneForDelivery'),
        },
        {
            path: '/home/adworkCapital',
            name: 'adworkCapital',
            component: r => require.ensure([], () => r(require('../components/antdiy/workCapital.vue')), 'adworkCapital'),
        },
        {
            path: '/home/serviceWorkOrderDetail',
            name: 'serviceWorkOrderDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/serviceWorkOrderDetail.vue')), 'serviceWorkOrderDetail'),
        },
        {
            path: '/home/logisticsWorkOrder',
            name: 'logisticsWorkOrder',
            component: r => require.ensure([], () => r(require('../components/antdiy/logisticsWorkOrder.vue')), 'logisticsWorkOrder'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/home/logisticsWorkOrderDetail',
            name: 'logisticsWorkOrderDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/logisticsWorkOrderDetail.vue')), 'logisticsWorkOrderDetail'),
        },
        {
            path: '/home/workPurchaseDetail',
            name: 'workPurchaseDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/workOrder/workPurchaseDetail.vue')), 'workPurchaseDetail'),
        },
        {
            path: '/home/workImproveDetail',
            name: 'workImproveDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/workOrder/workImproveDetail.vue')), 'workImproveDetail'),
        },
        {
            path: '/home/workPaymentDetail',
            name: 'workPaymentDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/workOrder/workPaymentDetail.vue')), 'workPaymentDetail'),
        },
        {
            path: '/home/workWarehousingDetail',
            name: 'workWarehousingDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/workOrder/workWarehousingDetail.vue')), 'workWarehousingDetail'),
        },
        {
            path: '/home/workReceivingDetail',
            name: 'workReceivingDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/workOrder/workReceivingDetail.vue')), 'workReceivingDetail'),
        },
        {
            path: '/home/workSignDetail',
            name: 'workSignDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/workOrder/workSignDetail.vue')), 'workSignDetail'),
        },
        {
            path: '/home/supplyAdOrderDetail',
            name: 'supplyAdOrderDetail',
            component: r => require.ensure([], () => r(require('../components/antdiy/workOrder/supplyAdOrderDetail.vue')), 'supplyAdOrderDetail'),
        },
        {
            path: '/home/fictitiousProuctDetail',
            name: 'fictitiousProuctDetail',
            component: r => require.ensure([], () => r(require('../components/itemcenter/fictitiousProuctDetail.vue')), 'fictitiousProuctDetail'),
        },
        {
            path: '/home/automationManage',
            name: 'automationManage',
            component: r => require.ensure([], () => r(require('../components/automation/automationManage.vue')), 'automationManage'),
        },
        {
            path: '/home/automationManageDetail',
            name: 'automationManageDetail',
            component: r => require.ensure([], () => r(require('../components/automation/automationManageDetail.vue')), 'automationManageDetail'),
        },
        {
            path: '/home/automationTemplate',
            name: 'automationTemplate',
            component: r => require.ensure([], () => r(require('../components/automation/automationTemplate.vue')), 'automationTemplate'),
        },
        {
            path: '/home/automationTemplateDetail',
            name: 'automationTemplateDetail',
            component: r => require.ensure([], () => r(require('../components/automation/automationTemplateDetail.vue')), 'automationTemplateDetail'),
        },
        {
            path: '/home/automationOdoo',
            name: 'automationOdoo',
            component: r => require.ensure([], () => r(require('../components/automation/automationOdoo.vue')), 'automationOdoo'),
        },
        {
            path: '/home/auditedGoods',
            name: 'auditedGoods',
            component: r => require.ensure([], () => r(require('../components/itemcenter/auditedGoods.vue')), 'auditedGoods'),
        },
        {
            path: '/home/auditGoods',
            name: 'auditGoods',
            component: r => require.ensure([], () => r(require('../components/itemcenter/auditGoods.vue')), 'auditGoods'),
        },
        {
            path: '/home/labelMana',
            name: 'labelMana',
            component: r => require.ensure([], () => r(require('../components/itemcenter/labelMana.vue')), 'labelMana'),
        },
        {
            path: '/home/chooseProductClues',
            name: 'chooseProductClues',
            component: r => require.ensure([], () => r(require('../components/itemcenter/chooseProductClues.vue')), 'chooseProductClues'),
        },
          {
            path: '/home/ecomhunt',
            name: 'ecomhunt',
            component: r => require.ensure([], () => r(require('../components/itemcenter/findExplosiveProducts/ecomhunt.vue')), 'ecomhunt'),
          },
          {
            path: '/home/adspy',
            name: 'adspy',
            component: r => require.ensure([], () => r(require('../components/itemcenter/findExplosiveProducts/adspy.vue')), 'adspy'),
          }, {
            path: '/home/crossBorderFindSame',
            name: 'crossBorderFindSame',
            component: r => require.ensure([], () => r(require('../components/itemcenter/findExplosiveProducts/crossBorderFindSame.vue')), 'crossBorderFindSame'),
          },  {
            path: '/home/crossFindSame',
            name: 'crossFindSame',
            component: r => require.ensure([], () => r(require('../components/itemcenter/findExplosiveProducts/crossFindSame.vue')), 'crossFindSame'),
          },   {
                path: '/home/fxFindSame',
                name: 'fxFindSame',
                component: r => require.ensure([], () => r(require('../components/itemcenter/findExplosiveProducts/fxFindSame.vue')), 'fxFindSame'),
              },  {
            path: '/home/component',
            name: 'component',
            component: r => require.ensure([], () => r(require('../components/itemcenter/findExplosiveProducts/component.vue')), 'component'),
          },
        {
            path: '/home/chooseSelf',
            name: 'chooseSelf',
            component: r => require.ensure([], () => r(require('../components/itemcenter/chooseSelf.vue')), 'chooseSelf'),
        },
        {
            path: '/home/materialGoods',
            name: 'materialGoods',
            component: r => require.ensure([], () => r(require('../components/itemcenter/materialGoods.vue')), 'materialGoods'),
        },
        {
            path: '/home/chooseOperRecords',
            name: 'chooseOperRecords',
            component: r => require.ensure([], () => r(require('../components/itemcenter/chooseOperRecords.vue')), 'chooseOperRecords'),
        },
        {
            path: '/home/analysisIncome',
            name: 'analysisIncome',
            component: r => require.ensure([], () => r(require('../components/antsupply/analysisIncome.vue')), 'analysisIncome'),
        },
        {
            path: '/home/analysisSell',
            name: 'analysisSell',
            component: r => require.ensure([], () => r(require('../components/antsupply/analysisSell.vue')), 'analysisSell'),
        },
        {
            path: '/home/analysisOrder',
            name: 'analysisOrder',
            component: r => require.ensure([], () => r(require('../components/antsupply/analysisOrder.vue')), 'analysisOrder'),
        },
        {
            path: '/home/analysisManage',
            name: 'analysisManage',
            component: r => require.ensure([], () => r(require('../components/antsupply/analysisManage.vue')), 'analysisManage'),
        },
        {
          path: '/home/imageSearchTool',
          name: 'imageSearchTool',
          component: r => require.ensure([], () => r(require('../components/itemcenter/imageSearchTool.vue')), 'imageSearchTool'),
          meta: {
            keepAlive: true // 需要缓存
          }
        },
        {
          path: '/home/pluginRecords',
          name: 'pluginRecords',
          component: r => require.ensure([], () => r(require('../components/itemcenter/pluginRecords.vue')), 'pluginRecords'),
          meta: {
            keepAlive: true // 需要缓存
          }
        },
        {
          path: '/home/imageSearchResult',
          name: 'imageSearchResult',
          component: r => require.ensure([], () => r(require('../components/itemcenter/imageSearchResult.vue')), 'imageSearchResult'),
        },
        {
          path: '/home/imageSearch',
          name: 'imageSearch',
          component: r => require.ensure([], () => r(require('../components/itemcenter/imageSearch.vue')), 'imageSearch'),
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/home/counterpartCommodityPool',
          name: 'counterpartCommodityPool',
          component: r => require.ensure([], () => r(require('../components/itemcenter/counterpartCommodityPool/counterpartCommodityPool.vue')), 'counterpartCommodityPool'),
        },
        {
          path: '/home/counterpartShopList',
          name: 'counterpartShopList',
          component: r => require.ensure([], () => r(require('../components/itemcenter/counterpartCommodityPool/counterpartShopList.vue')), 'counterpartShopList'),
        },
        {
          path: '/home/demandWordTaskList',
          name: 'demandWordTaskList',
          component: r => require.ensure([], () => r(require('../components/itemcenter/demandWordTaskList.vue')), 'demandWordTaskList'),
        },
        {
          path: '/home/demandWordTaskReasult',
          name: 'demandWordTaskReasult',
          component: r => require.ensure([], () => r(require('../components/itemcenter/demandWordTaskReasult.vue')), 'demandWordTaskReasult'),
        },
        {
            path: '/home/pitcherClues',
            name: 'pitcherClues',
            component: r => require.ensure([], () => r(require('../components/itemcenter/pitcherClues/pitcherClues.vue')), 'pitcherClues'),
        },
        {
            path: '/home/findMaterial',
            name: 'findMaterial',
            component: r => require.ensure([], () => r(require('../components/itemcenter/findMaterial.vue')), 'findMaterial'),
        },
        {
            path: '/home/customerLeads',
            name: 'customerLeads',
            component: r => require.ensure([], () => r(require('../components/itemcenter/customerLeads.vue')), 'customerLeads'),
        },
        {
            path: '/home/shippingCalculator',
            name: 'shippingCalculator',
            component: r => require.ensure([], () => r(require('../components/itemcenter/shippingCalculator.vue')), 'shippingCalculator'),
        },
        {
            path: '/home/globalCloudStore',
            name: 'globalCloudStore',
            component: r => require.ensure([], () => r(require('../components/antdiy/globalCloudStore/globalCloudStore.vue')), 'globalCloudStore'),
        },
        {
            path: '/home/cloudStoreManger',
            name: 'cloudStoreManger',
            component: r => require.ensure([], () => r(require('../components/antdiy/globalCloudStore/cloudStoreManger.vue')), 'globalCloudStore'),
        },
        {
            path: '/home/globalCloudStore/appManager',
            name: 'appManager',
            component: r => require.ensure([], () => r(require('../components/antdiy/globalCloudStore/appManager.vue')), 'globalCloudStore'),
        },
        {
            path: '/home/globalCloudStore/siteManager',
            name: 'siteManager',
            component: r => require.ensure([], () => r(require('../components/antdiy/globalCloudStore/siteManager.vue')), 'globalCloudStore'),
        },
        {
            path: '/home/commodityPool1688',
            name: 'commodityPool1688',
            component: r => require.ensure([], () => r(require('../components/itemcenter/commodityPool1688/commodityPool1688.vue')), 'commodityPool1688'),
        },
        {
            path: '/home/advertiserFavorites',
            name: 'advertiserFavorites',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertiserFavorites.vue')), 'advertiserFavorites'),
        },
        {
            path: '/home/advertiserFavoritesDetail/:name',
            name: 'advertiserFavoritesDetail',
            component: () => import('../components/itemcenter/advertiserFavoritesDetail.vue'),
            props: true
          },
          {
            path: '/home/advertiserFavoritesList', // 去掉动态参数
            name: 'advertiserFavoritesList',
            component: () => import('../components/itemcenter/advertiserFavoritesList.vue'),
            props: true
          },
        {
            path: '/home/commodityPool1688Copy',
            name: 'commodityPool1688Copy',
            component: r => require.ensure([], () => r(require('../components/itemcenter/commodityPool1688/commodityPool1688Copy.vue')), 'commodityPool1688Copy'),
        },
              {
                path: '/home/categoryDetails/:oneCategory',
                name: 'categoryDetails',
                component: r => require.ensure([], () => r(require('../components/itemcenter/categoryDetails.vue')), 'categoryDetails'),
                props: true
              },
        {
            path: '/home/dropFunnel',
            name: 'dropFunnel',
            component: r => require.ensure([], () => r(require('../components/itemcenter/dropFunnel.vue')), 'dropFunnel'),
        },
        {
            path: '/home/advertisingList',
            name: 'advertisingList',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/advertisingList.vue')), 'advertisingList'),
        },
        {
            path: '/home/adsSiteGroup',
            name: 'adsSiteGroup',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/adsSiteGroup.vue')), 'adsSiteGroup'),
        },
          {
            path: '/home/adsSpu',
            name: 'adsSpu',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/adsSpu.vue')), 'adsSpu'),
          },
        {
            path: '/home/advertisingMonitoring',
            name: 'advertisingMonitoring',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/advertisingMonitoring.vue')), 'advertisingMonitoring'),
        },
          {
            path: '/home/adsSiteMonitoring',
            name: 'adsSiteMonitoring',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/adsSiteMonitoring.vue')), 'adsSiteMonitoring'),
          },
          {
            path: '/home/adsSiteRel',
            name: 'adsSiteRel',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/adsSiteRel.vue')), 'adsSiteRel'),
          },
          {
            path: '/home/ipDetailes',
            name: 'ipDetailes',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/ipDetailes.vue')), 'ipDetailes'),
          },
        {
            path: '/home/reconciliationCenter',
            name: 'reconciliationCenter',
            component: r => require.ensure([], () => r(require('../components/bankrollMana/reconciliationCenter.vue')), 'reconciliationCenter'),
            children:[
                {
                    path: '/home/reconciliationCenter/purchase',
                    name: 'purchase',
                    component: r => require.ensure([], () => r(require('../components/bankrollMana/purchase.vue')), 'purchase'),
                },
                {
                    path: '/home/reconciliationCenter/purchaseDetail',
                    name: 'purchaseDetail',
                    component: r => require.ensure([], () => r(require('../components/bankrollMana/purchaseDetail.vue')), 'purchaseDetail'),
                },
              ]
        },
        {
            path: '/home/exportFileByLinks',
            name: 'exportFileByLinks',
            component: r => require.ensure([], () => r(require('../components/itemcenter/exportFileByLinks.vue')), 'exportFileByLinks'),
          },
          {
            path: '/home/advertisingTracking',
            name: 'advertisingTracking',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingTracking.vue')), 'advertisingTracking'),
          },
          {
            path: '/home/gpt',
            name: 'gpt',
            component: r => require.ensure([], () => r(require('../components/itemcenter/gpt.vue')), 'gpt'),
          },
          {
            path: '/home/productSimmilar',
            name: 'productSimmilar',
            component: r => require.ensure([], () => r(require('../components/itemcenter/productSimmilar/productSimmilar.vue')), 'productSimmilar'),
          },
          {
            path: '/home/metaBase',
            name: 'metaBase',
            component: r => require.ensure([], () => r(require('../components/itemcenter/metaBase.vue')), 'metaBase'),
          },
          {
            path: '/home/facebookKeyWord',
            name: 'facebookKeyWord',
            component: r => require.ensure([], () => r(require('../components/itemcenter/facebookKeyWord.vue')), 'facebookKeyWord'),
          },
          {
            path: '/home/facebookSystemAnalysis',
            name: 'facebookSystemAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/facebookSystemAnalysis.vue')), 'facebookSystemAnalysis'),
          },
          {
            path: '/home/facebookStartTime',
            name: 'facebookStartTime',
            component: r => require.ensure([], () => r(require('../components/itemcenter/facebookStartTime.vue')), 'facebookStartTime'),
          },
          {
            path: '/home/facebookNewAdvertiser',
            name: 'facebookNewAdvertiser',
            component: r => require.ensure([], () => r(require('../components/itemcenter/facebookNewAdvertiser.vue')), 'facebookNewAdvertiser'),
          },
          {
            path: '/home/behaviorAnalysis',
            name: 'behaviorAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/behaviorAnalysis.vue')), 'behaviorAnalysis'),
          },
          {
            path: '/home/batchProcessing',
            name: 'batchProcessing',
            component: r => require.ensure([], () => r(require('../components/itemcenter/batchProcessing.vue')), 'batchProcessing'),
          },
          {
            path: '/home/audienceStatistics',
            name: 'audienceStatistics',
            component: r => require.ensure([], () => r(require('../components/itemcenter/audienceStatistics.vue')), 'audienceStatistics'),
          },
          {
            path: '/home/audienceAccountStats',
            name: 'audienceAccountStats',
            component: r => require.ensure([], () => r(require('../components/itemcenter/audienceAccountStats.vue')), 'audienceAccountStats'),
          },
          {
            path: '/home/competitorProfile',
            name: 'competitorProfile',
            component: r => require.ensure([], () => r(require('../components/itemcenter/competitorProfile.vue')), 'competitorProfile'),
          },
          {
            path: '/home/advertiserCountryCognitiveMap',
            name: 'advertiserCountryCognitiveMap',
            meta: { title: '广告主国家认知地图' },
            component: r => require.ensure([], () => r(require('../components/itemcenter/AdvertiserCountryCognitiveMap.vue')), 'advertiserCountryCognitiveMap'),
          },
          {
            path: '/home/advertiserTiers',
            name: 'advertiserTiers',
            meta: { title: '广告主国家能力分析' },
            component: r => require.ensure([], () => r(require('../components/itemcenter/AdvertiserTiers.vue')), 'advertiserTiers'),
          },
          {
            path: '/home/competitorGrowth',
            name: 'competitorGrowth',
            meta: { title: '竞品增长汇总' },
            component: r => require.ensure([], () => r(require('../components/itemcenter/CompetitorGrowth.vue')), 'competitorGrowth'),
          },
          {
            path: '/home/excludeAccount',
            name: 'excludeAccount',
            component: r => require.ensure([], () => r(require('../components/itemcenter/excludeAccount.vue')), 'excludeAccount'),
          },
          {
            path: '/home/audienceManage',
            name: 'audienceManage',
            component: r => require.ensure([], () => r(require('../components/itemcenter/audienceManage.vue')), 'audienceManage'),
          },
          {
            path: '/home/advertisingUpgrade',
            name: 'advertisingUpgrade',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingUpgrade.vue')), 'advertisingUpgrade'),
          },
          {
            path: '/home/advertiseInterect',
            name:'advertiseInterect',
            component: r => require.ensure([],() => r(require('../components/itemcenter/advertiseInterect.vue')),'advertiseInterect'),
          },
          {
            path: '/home/cboadvertising',
            name: 'cboadvertising',
            component: r => require.ensure([], () => r(require('../components/itemcenter/cboadvertising.vue')), 'cboadvertising'),
          },
          {
            path: '/home/ascadvertising',
            name: 'ascadvertising',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ascadvertising.vue')), 'ascadvertising'),
          },
          {
            path: '/home/adTemplateLaunch',
            name: 'adTemplateLaunch',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adTemplateLaunch.vue')), 'adTemplateLaunch'),
          },
          // V3 L1 策略模板组合器（S0+S1 脚手架；不改 adTemplateLaunch）
          {
            path: '/home/v3/strategyComposer',
            name: 'v3StrategyComposer',
            component: r => require.ensure([], () => r(require('../components/itemcenter/v3/strategyComposer.vue')), 'v3StrategyComposer'),
          },
          // V3 L2 微调台（空骨架 P-DESK-SKEL；不接 Prefill/Confirm；不改旧投放页）
          {
            path: '/home/v3/tuningDesk',
            name: 'v3TuningDesk',
            component: r => require.ensure([], () => r(require('../components/itemcenter/v3/tuningDesk.vue')), 'v3TuningDesk'),
          },
          {
            path: '/home/adLaunchSnapshotRecord',
            name: 'adLaunchSnapshotRecord',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adLaunchSnapshotRecord.vue')), 'adLaunchSnapshotRecord'),
          },
          // 竞品商详编辑：按 advertiseId 走库/fork，与 productEdit（Facebook 广告 ID）分离
          {
            path: '/home/competitorProductEdit',
            name: 'competitorProductEdit',
            component: r => require.ensure([], () => r(require('../components/itemcenter/competitorProductEdit.vue')), 'competitorProductEdit'),
          },
          {
            path:'/home/muchenAd',
            name:'muchenAd02',
            component: r => require.ensure([],() => r(require('../components/itemcenter/MuchenAdList02.vue')),'muchenAd02'),
          },
          {
            path: '/home/auditAdvertising',
            name: 'auditAdvertising',
            component: r => require.ensure([], () => r(require('../components/itemcenter/auditAdvertising.vue')), 'auditAdvertising'),
          },
          {
            path: '/home/competitiveStatus',
            name: 'competitiveStatus',
            component: r => require.ensure([], () => r(require('../components/itemcenter/competitiveStatus.vue')), 'competitiveStatus'),
          },
          {
            path: '/home/useAdDataUpdate',
            name: 'useAdDataUpdate',
            component: r => require.ensure([], () => r(require('../components/itemcenter/useAdDataUpdate.vue')), 'useAdDataUpdate'),
          },
          {
            path: '/home/batchFacebookPage',
            name: 'batchFacebookPage',
            component: r => require.ensure([], () => r(require('../components/itemcenter/batchFacebookPage.vue')), 'batchFacebookPage'),
          },
          {
            path: '/home/sspuDataAggregation',
            name: 'sspuDataAggregation',
            component: r => require.ensure([], () => r(require('../components/itemcenter/sspuDataAggregation.vue')), 'sspuDataAggregation'),
          },
          {
            path: '/home/advertisingSearch',
            name: 'advertisingSearch',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingSearch.vue')), 'advertisingSearch'),
          },
          {
            path: '/home/sspuDataAggregation/detail/:similarId',
            name: 'detailPage',
            component: r => require.ensure([], () => r(require('../components/itemcenter/detailPage.vue')), 'detailPage'),
            meta: { requiresAuth: false }
          },
          {
            path: '/home/advertising',
            name: 'advertising',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertising.vue')), 'advertising'),
          },
          {
            path: '/home/behaviorAnalysisDetail',
            name: 'behaviorAnalysisDetail',
            component: r => require.ensure([], () => r(require('../components/itemcenter/behaviorAnalysisDetail.vue')), 'behaviorAnalysisDetail'),
          },
          {
            path: '/home/adsDataReport',
            name: 'adsDataReport',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/adsDataReport.vue')), 'adsDataReport'),
          },
          {
            path: '/home/adsDataReportNew',
            name: 'adsDataReportNew',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/adsDataReportNew.vue')), 'adsDataReport'),
          },
          {
            path: '/home/adsDataReportOld',
            name: 'adsDataReportOld',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/adsDataReportOld.vue')), 'adsDataReport'),
          },
          {
            path: '/home/adsDataReportDetail',
            name: 'adsDataReportDetail',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/adsDataReportDetail.vue')), 'adsDataReport'),
          },
          {
            path: '/home/pageMonitoring',
            name: 'pageMonitoring',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/pageMonitoring.vue')), 'adsDataReport'),
          },
          {
            path: '/home/advertisingInsight',
            name: 'advertisingInsight',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/advertisingInsight.vue')), 'advertisingInsight'),
          },
          {
            path: '/home/accountData',
            name: 'accountData',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/accountData.vue')), 'accountData'),
          },
          {
            path: '/home/advertisingData',
            name: 'advertisingData',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/advertisingData.vue')), 'advertisingData'),
          },
          {
            path: '/home/advertisingAuth',
            name: 'advertisingAuth',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/advertisingAuth.vue')), 'advertisingAuth'),
          },
          {
            path: '/home/commodityDimension',
            name: 'commodityDimension',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/commodityDimension.vue')), 'commodityDimension'),
          },
          {
            path: '/home/shopOrderNumber',
            name: 'shopOrderNumber',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/shopOrderNumber.vue')), 'shopOrderNumber'),
          },

          {
            path: '/home/alibabaAdRelation',
            name: 'alibabaAdRelation',
            component: r => require.ensure([], () => r(require('../components/itemcenter/alibabaAdRelation/alibabaAdRelation.vue')), 'alibabaAdRelation'),
          },
          {
            path: '/home/adsHoursData',
            name: 'adsHoursData',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMonitoring/adsHoursData.vue')), 'adsDataReport'),
          },
          {
            path: '/home/businessAnalysis',
            name: 'businessAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/businessAnalysis.vue')), 'businessAnalysis'),
          },
          {
            path: '/home/commodityPoolStar',
            name: 'commodityPoolStar',
            component: r => require.ensure([], () => r(require('../components/itemcenter/commodityPoolStar/commodityPoolStar.vue')), 'commodityPoolStar'),
          },
          {
            path: '/home/storeClues/baiJing',
            name: 'baiJing',
            component: r => require.ensure([], () => r(require('../components/itemcenter/storeClues/baiJing.vue')), 'baiJing'),
          },
          {
            path: '/home/operatingStatements',
            name: 'operatingStatements',
            component: r => require.ensure([], () => r(require('../components/pitcherWorkbench/operatingStatements/operatingStatements.vue')), 'operatingStatements'),
          },
          {
            path: '/home/financialReconciliation',
            name: 'financialReconciliation',
            component: r => require.ensure([], () => r(require('../components/pitcherWorkbench/operatingStatements/financialReconciliation.vue')), 'financialReconciliation'),
          },
          {
            path: '/home/feeRecord',
            name: 'feeRecord',
            component: r => require.ensure([], () => r(require('../components/pitcherWorkbench/operatingStatements/feeRecord.vue')), 'feeRecord'),
          },
          {
            path: '/home/gaode',
            name: 'gaode',
            component: r => require.ensure([], () => r(require('../components/pitcherWorkbench/operatingStatements/gaode.vue')), 'gaode'),
          },
          {
            path: '/home/leaflet',
            name: 'leaflet',
            component: r => require.ensure([], () => r(require('../components/pitcherWorkbench/operatingStatements/leaflet.vue')), 'leaflet'),
          },
          {
            path: '/home/googleMap',
            name: 'googleMap',
            component: r => require.ensure([], () => r(require('../components/pitcherWorkbench/operatingStatements/googleMap.vue')), 'googleMap'),
          },
          {
            path: '/home/warehousingEntry',
            name: 'warehousingEntry',
            component: r => require.ensure([], () => r(require('../components/pitcherWorkbench/operatingStatements/warehousingEntry.vue')), 'warehousingEntry'),
          },
          {
            path: '/home/logisticsReconciliation',
            name: 'logisticsReconciliation',
            component: r => require.ensure([], () => r(require('../components/pitcherWorkbench/operatingStatements/logisticsReconciliation.vue')), 'logisticsReconciliation'),
          },
          {
            path: '/home/facebookAdDetail',
            name: 'facebookAdDetail',
            component: r => require.ensure([], () => r(require('../components/itemcenter/commodityPool1688/facebookAdDetail.vue')), 'facebookAdDetail'),

          },
          {
            path: '/home/advertisementCatalogue',
            name: 'advertisementCatalogue',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisementCatalogue/advertisementCatalogue.vue')), 'advertisementCatalogue'),
          },
          {
            path: '/home/manageStatement',
            name: 'manageStatement',
            component: r => require.ensure([], () => r(require('../components/itemcenter/manageStatement.vue')), 'manageStatement'),
          },
          {
            path: '/home/advertisingMigration',
            name: 'advertisingMigration',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingMigration.vue')), 'advertisingMigration'),
          },
          {
            path: '/home/dailyRecommenda',
            name: 'dailyRecommenda',
            component: r => require.ensure([], () => r(require('../components/itemcenter/dailyRecommenda.vue')), 'dailyRecommenda'),
          },
          {
            path: '/home/adDaydata',
            name: 'adDaydata',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adDaydata.vue')), 'adDaydata'),
          },
          {
            path: '/home/adOperationRecord',
            name: 'adOperationRecord',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adOperationRecord.vue')), 'adOperationRecord'),
          },
          {
            path: '/home/adDeliveryRecord',
            name: 'adDeliveryRecord',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adDeliveryRecord.vue')), 'adDeliveryRecord'),
          },
          {
            path: '/home/bossChatRecruit',
            name: 'bossChatRecruit',
            component: r => require.ensure([], () => r(require('../components/itemcenter/bossChatRecruit.vue')), 'bossChatRecruit'),
          },
          {
            path: '/home/bossChatRecruitPool',
            name: 'bossChatRecruitPool',
            component: r => require.ensure([], () => r(require('../components/itemcenter/bossChatRecruitPool.vue')), 'bossChatRecruitPool'),
          },
          {
            path: '/home/bossChatRecruitFunnel',
            redirect: '/home/bossChatRecruit',
          },
          {
            path: '/home/adDynamicBudget',
            name: 'adDynamicBudget',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adDynamicBudget.vue')), 'adDynamicBudget'),
          },
            {
            path: '/home/vectorKMeans',
            name: 'vectorKMeans',
            component: r => require.ensure([], () => r(require('../components/itemcenter/vectorKMeans.vue')), 'vectorKMeans'),
          },
          {
            path: '/home/competitorFusion3D',
            name: 'competitorFusion3D',
            component: r => require.ensure([], () => r(require('../components/itemcenter/CompetitorFusion3D.vue')), 'competitorFusion3D'),
          },
          {
            path: '/home/competitorHeatmap',
            name: 'competitorHeatmap',
            component: r => require.ensure([], () => r(require('../components/itemcenter/CompetitorHeatmap.vue')), 'competitorHeatmap'),
          },
          {
            path: '/home/competitorFusion3DNeighbor',
            name: 'competitorFusion3DNeighbor',
            component: r => require.ensure([], () => r(require('../components/itemcenter/CompetitorFusion3DNeighbor.vue')), 'competitorFusion3DNeighbor'),
          },
          {
            path: '/home/competitorFusion3DEnhanced',
            name: 'competitorFusion3DEnhanced',
            component: r => require.ensure([], () => r(require('../components/itemcenter/CompetitorFusion3DEnhanced.vue')), 'competitorFusion3DEnhanced'),
          },
          {
            path: '/home/competitorCognitiveMap',
            name: 'competitorCognitiveMap',
            component: r => require.ensure([], () => r(require('../components/itemcenter/CompetitorCognitiveMap.vue')), 'competitorCognitiveMap'),
          },
          {
            path: '/home/competitorCognitiveAnalysis',
            name: 'competitorCognitiveAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/CompetitorCognitiveAnalysis.vue')), 'competitorCognitiveAnalysis'),
            meta: { title: '竞品认知方向分析' }
          },
          {
            path: '/home/advertiserCognitiveAnalysis',
            name: 'advertiserCognitiveAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/advertiser/AdvertiserCognitiveAnalysis.vue')), 'advertiserCognitiveAnalysis'),
            meta: { title: '广告主分析' }
          },
          {
            path: '/home/competitorFusion3DAdvertised',
            name: 'competitorFusion3DAdvertised',
            component: r => require.ensure([], () => r(require('../components/itemcenter/CompetitorFusion3DAdvertised.vue')), 'competitorFusion3DAdvertised'),
          },
          {
            path: '/home/advertiseTimeline',
            name: 'advertiseTimeline',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertiseTimeline.vue')), 'advertiseTimeline'),
          },
            {
            path: '/home/advertiseVector',
            name: 'advertiseVector',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertiseVector.vue')), 'advertiseVector'),
          },
            {
            path: '/home/advertisingVectorRecommendation',
            name: 'advertisingVectorRecommendation',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertisingVectorRecommendation.vue')), 'advertisingVectorRecommendation'),
          },
          {
            path: '/home/ai/chatAgent',
            name: 'chatAgent',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/chatAgent.vue')), 'chatAgent'),
          },
          {
            path: '/home/ai/TaskManager',
            name: 'TaskManager',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/TaskManager.vue')), 'TaskManager'),
          },
          {
            path: '/home/ai/TaskSubTaskCenter',
            name: 'TaskSubTaskCenter',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/TaskSubTaskCenter.vue')), 'TaskSubTaskCenter'),
          },
          {
            path: '/home/ai/TaskLogCenter',
            name: 'TaskLogCenter',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/TaskLogCenter.vue')), 'TaskLogCenter'),
          },
          {
            path: '/home/ai/ReviewPanel',
            name: 'ReviewPanel',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/ReviewPanel.vue')), 'ReviewPanel'),
          },
          {
            path: '/home/ai/TaskVersionHistory',
            name: 'TaskVersionHistory',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/TaskVersionHistory.vue')), 'TaskVersionHistory'),
          },
          {
            path: '/home/ai/SessionTimeline',
            name: 'SessionTimeline',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/SessionTimeline.vue')), 'SessionTimeline'),
          },
          {
            path: '/home/ai/TaskOpsCenter',
            name: 'TaskOpsCenter',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/TaskLogCenter.vue')), 'TaskLogCenter'),
          },
          {
            path: '/home/adAccAssetGrowth',
            name: 'adAccAssetGrowth',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adAccAssetGrowth.vue')), 'adAccAssetGrowth'),
          },
          {
            path: '/home/getAllAdInfo',
            name: 'getAllAdInfo',
            component: r => require.ensure([], () => r(require('../components/itemcenter/getAllAdInfo.vue')), 'getAllAdInfo'),
          },
          {
            path: '/home/advertiseAnalyzeService',
            name: 'advertiseAnalyzeService',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertiseAnalyzeService.vue')), 'advertiseAnalyzeService'),

          },
          {
            path: '/home/competitorCountryMap3D',
            name: 'competitorCountryMap3D',
            component: r => require.ensure([], () => r(require('../components/itemcenter/CompetitorCountryMap3D.vue')), 'competitorCountryMap3D'),
          },
          {
            path: '/home/accountAnalyzeService',
            name: 'accountAnalyzeService',
            component: r => require.ensure([], () => r(require('../components/itemcenter/accountAnalyzeService.vue')), 'accountAnalyzeService'),

          },
          {
            path: '/home/findSimilarCompetitors',
            name: 'findSimilarCompetitors',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adAccAssetGrowth/findSimilarCompetitors.vue')), 'findSimilarCompetitors'),
          },
          {
            path: '/home/behavioralDistributionPatterns',
            name: 'behavioralDistributionPatterns',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adAccAssetGrowth/behavioralDistributionPatterns.vue')), 'behavioralDistributionPatterns'),

          },
          {
            path: '/home/behavioralDistributionPatternsDateRange',
            name: 'behavioralDistributionPatternsDateRange',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adAccAssetGrowth/behavioralDistributionPatternsDateRange.vue')), 'behavioralDistributionPatternsDateRange'),

          },
          {
            path: '/home/lastDayAdDiagnosis',
            name: 'lastDayAdDiagnosis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adAccAssetGrowth/lastDayAdDiagnosis.vue')), 'lastDayAdDiagnosis'),

          },
          {
            path: '/home/detailedAnalysisOfAdvertisements',
            name: 'detailedAnalysisOfAdvertisements',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adAccAssetGrowth/detailedAnalysisOfAdvertisements.vue')), 'behavioralDistributionPatterns'),

          },
          {
            path: '/home/base/facebookAccountInfo',
            name: 'facebookAccountInfo',
            component: r => require.ensure([], () => r(require('../components/itemcenter/baseInfo/facebookAccountInfo.vue')), 'facebookAccountInfo'),

          },
          {
            path: '/home/base/facebookAudienceInfo',
            name: 'facebookAudienceInfo',
            component: r => require.ensure([], () => r(require('../components/itemcenter/baseInfo/facebookAudienceInfo.vue')), 'facebookAudienceInfo'),

          },
          {
            path: '/home/base/facebookAdData',
            name: 'facebookAdData',
            component: r => require.ensure([], () => r(require('../components/itemcenter/baseInfo/facebookAdData.vue')), 'facebookAdData'),

          },
          {
            path: '/home/base/facebookAdDataLatest',
            name: 'facebookAdDataLatest',
            component: r => require.ensure([], () => r(require('../components/itemcenter/baseInfo/facebookAdDataLatest.vue')), 'facebookAdDataLatest'),
          },
          {
            path: '/home/blueOceanPopulationAnalysis',
            name: 'blueOceanPopulationAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adAccAssetGrowth/blueOceanPopulationAnalysis.vue')), 'blueOceanPopulationAnalysis'),

          },
          {
            path: '/home/ageGenderMixedRecommendation',
            name: 'ageGenderMixedRecommendation',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adAccAssetGrowth/ageGenderMixedRecommendation.vue')), 'ageGenderMixedRecommendation'),

          },
          {
            path: '/home/ai/DiscoveryPanel',
            name: 'DiscoveryPanel',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/DiscoveryPanel.vue')), 'DiscoveryPanel'),

          },
          {
            path: '/home/ai/thoughtMining',
            name: 'ThoughtMiningPanel',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/ThoughtMiningPanel.vue')), 'ThoughtMiningPanel'),
            meta: { title: '想法挖掘' }
          },
          {
            path: '/home/ai/advertiserRoute/result/:id',
            name: 'AdvertiserRouteResult',
            component: () => import('../components/itemcenter/ai/advertiserRoute/AdvertiserRouteResult.vue'),
            meta: { title: '起号路线结果' }
          },
          {
            path: '/home/ai/advertiserRoute',
            name: 'AdvertiserRoute',
            component: () => import('../components/itemcenter/ai/advertiserRoute/AdvertiserRoute.vue'),
            meta: { title: '广告主起号路线' }
          },
          {
            path: '/home/ai/thoughtPanel',
            name: 'ThoughtPanel',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/ThoughtPanel.vue')), 'ThoughtPanel'),
            meta: { title: '想法管理' }
          },
          {
            path: '/home/ai/personaPanel',
            name: 'PersonaPanel',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ai/PersonaPanel.vue')), 'PersonaPanel'),
            meta: { title: '画像管理' }
          },
          {
            path: '/home/adPlacement/onDuty',
            name: 'AdPlacementOnDuty',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/Empty.vue')), 'AdPlacementEmpty'),
          },
          {
            path: '/home/adPlacement/player',
            name: 'AdPlacementPlayer',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/Empty.vue')), 'AdPlacementEmpty'),
          },
          {
            path: '/home/adPlacement/director',
            name: 'AdPlacementDirector',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/Empty.vue')), 'AdPlacementEmpty'),
          },
          {
            path: '/home/adPlacement/adCostView',
            name: 'AdCostView',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/adCostView.vue')), 'AdCostView'),
          },
          {
            path: '/home/adPlacement/adAccountDaily',
            name: 'AdAccountDaily',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/adAccountDaily.vue')), 'AdAccountDaily'),
          },
          {
            path: '/home/adPlacement/audienceLineage',
            name: 'AudienceLineage',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/audienceLineage.vue')), 'AudienceLineage'),
          },
          {
            path: '/home/adPlacement/adAccountDailyLineage',
            name: 'AdAccountDailyLineage',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/adAccountDailyLineage.vue')), 'AdAccountDailyLineage'),
          },
          {
            path: '/home/adPlacement/assetCrossMatrix',
            name: 'AssetCrossMatrix',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/assetCrossMatrix.vue')), 'AssetCrossMatrix'),
          },
          {
            path: '/home/adPlacement/assetCrossMatrixByIds',
            name: 'AssetCrossMatrixByIds',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/assetCrossMatrixByIds.vue')), 'AssetCrossMatrixByIds'),
          },
          {
            path: '/home/adPlacement/assetCrossMatrixTwoLevel',
            name: 'AssetCrossMatrixTwoLevel',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/assetCrossMatrixTwoLevel.vue')), 'AssetCrossMatrixTwoLevel'),
          },
          {
            path: '/home/adPlacement/competitorAdBoard',
            name: 'CompetitorAdBoard',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/CompetitorAdBoard.vue')), 'CompetitorAdBoard'),
          },
          {
            path: '/home/adPlacement/competitorAdAggregation',
            name: 'CompetitorAdAggregation',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/CompetitorAdAggregation.vue')), 'CompetitorAdAggregation'),
          },
          {
            path: '/home/adPlacement/adDiagnosticBoard',
            name: 'AdDiagnosticBoard',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/AdDiagnosticBoard.vue')), 'AdDiagnosticBoard'),
          },
          {
            path: '/home/adPlacement/adLifecycleBoard',
            name: 'AdLifecycleBoard',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/adLifecycleBoard.vue')), 'AdLifecycleBoard'),
          },
          {
            path: '/home/adPlacement/adDataAnalysis',
            name: 'AdDataAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/adDataAnalysis.vue')), 'AdDataAnalysis'),
          },
          {
            path: '/home/adPlacement/adSummary30d',
            name: 'AdSummary30d',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/adSummary30d.vue')), 'AdSummary30d'),
          },
          {
            path: '/home/adPlacement/adBudgetDecision',
            name: 'AdBudgetDecision',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adBudgetDecision')), 'AdBudgetDecision'),
          },
          {
            path: '/home/adPlacement/signRateAnalysis',
            name: 'SignRateAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPlacement/signRateAnalysis.vue')), 'SignRateAnalysis'),
          },
          {
            path: '/home/adTestAssociation',
            name: 'AdTestAssociation',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adTestAssociation')), 'AdTestAssociation'),
            meta: { title: '投放测试关联' }
          },
          {
            path: '/home/adTestSpacetimeAtlas',
            name: 'AdTestSpacetimeAtlas',
            component: r => require.ensure([], () => r(require('../components/itemcenter/AdTestSpacetimeAtlasPage')), 'AdTestSpacetimeAtlas'),
            meta: { title: '投放测试时空树谱' }
          },
          {
            path: '/home/adCompetitorComparison',
            name: 'AdCompetitorComparison',
            component: r => require.ensure([], () => r(require('../components/itemcenter/AdCompetitorComparisonPage')), 'AdCompetitorComparison'),
            meta: { title: '竞品阶段数据对比' }
          },
          {
            path: '/home/adPhaseAnalysis',
            name: 'AdPhaseAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adPhaseAnalysis')), 'AdPhaseAnalysis'),
            meta: { title: '广告阶段表现分析' }
          },
          {
            path: '/home/adValueRuleAnalysis',
            name: 'AdValueRuleAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adValueRuleAnalysis')), 'AdValueRuleAnalysis'),
            meta: { title: 'Facebook价值规则分析' }
          },
          {
            path: '/home/adTestReport',
            name: 'AdTestReport',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adTestReport')), 'AdTestReport'),
            meta: { title: '投放测试广告报告' }
          },
          {
            path: '/home/adAccAssetGrowthECpm',
            name: 'adAccAssetGrowthECpm',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adAccAssetGrowth/adAccAssetGrowthECpm.vue')), 'adAccAssetGrowthECpm'),
          },
          {
            path: '/home/adTrendAnalysis',
            name: 'adTrendAnalysis',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adAccAssetGrowth/adTrendAnalysis.vue')), 'adTrendAnalysis'),
          },
                      {
            path: '/home/adLaunchRecord',
            name: 'adLaunchRecord',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adLaunchRecord.vue')), 'adLaunchRecord'),
          },
            {
            path: '/home/accountCrossVectorSearch',
            name: 'accountCrossVectorSearch',
            component: r => require.ensure([], () => r(require('../components/itemcenter/accountCrossVectorSearch.vue')), 'accountCrossVectorSearch'),
          },
              {
            path: '/home/accountCrossVectorMatch',
            name: 'accountCrossVectorMatch',
            component: r => require.ensure([], () => r(require('../components/itemcenter/accountCrossVectorMatch.vue')), 'accountCrossVectorMatch'),
          },
          {
            path: '/home/ruleManagement',
            name: 'ruleManagement',
            component: r => require.ensure([], () => r(require('../components/itemcenter/ruleManagement.vue')), 'ruleManagement'),
          },
          {
            path: '/home/productEdit',
            name: 'productEdit',
            component: r => require.ensure([], () => r(require('../components/itemcenter/productEdit.vue')), 'productEdit'),
          },
          {
            path: '/home/dailyAdRecommend',
            name: 'dailyAdRecommend',
            component: r => require.ensure([], () => r(require('../components/itemcenter/dailyAdRecommend.vue')), 'dailyAdRecommend'),
          },
          {
            path: '/home/advertiserMain',
            name: 'advertiserMain',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertiserMain.vue')), 'advertiserMain'),
          },
           {
            path: '/home/advertiserExcel',
            name: 'advertiserExcel',
            component: r => require.ensure([], () => r(require('../components/itemcenter/advertiserExcel.vue')), 'advertiserExcel'),
          },
          {
            path: '/home/adCartAndOrderShow',
            name: 'adCartAndOrderShow',
            component: r => require.ensure([], () => r(require('../components/itemcenter/adCartAndOrderShow.vue')), 'adCartAndOrderShow'),
          },
           {
            path: '/home/accountMatch',
            name: 'accountMatch',
            component: r => require.ensure([], () => r(require('../components/itemcenter/accountMatch.vue')), 'accountMatch'),
          },
          {
            path: '/home/accountAdChart',
            name: 'accountAdChart',
            component: r => require.ensure([], () => r(require('../components/itemcenter/accountAdChart.vue')), 'accountAdChart'),
          },
          {
            path: '/home/facebookCatalogue',
            name: 'facebookCatalogue',
            component: r => require.ensure([], () => r(require('../components/itemcenter/facebookCatalogue.vue')), 'facebookCatalogue'),
          },
          {
            path: '/home/facebookCatalogueAliveDay',
            name: 'facebookCatalogueAliveDay',
            component: r => require.ensure([], () => r(require('../components/itemcenter/facebookCatalogueAliveDay.vue')), 'facebookCatalogueAliveDay'),
          },
              {
                path: '/home/mergeAdMaster',
                name: 'mergeAdMaster',
                component: r => require.ensure([], () => r(require('../components/itemcenter/commodityPool1688/mergeAdMaster.vue')), 'mergeAdMaster'),
              },
          {
            path: '/home/antdiyRepertory',
            name: 'antdiyRepertory',
            component: r => require.ensure([], () => r(require('../components/antdiy/antdiyRepertory.vue')), 'antdiyRepertory'),
          },
              {
                path: '/home/adRate',
                name: 'adRate',
                component: r => require.ensure([], () => r(require('../components/adRate.vue')), 'adRate'),
              },
              {
                path: '/home/basin',
                name: 'basin',
                component: r => require.ensure([], () => r(require('../components/itemcenter/commodityPool1688/basin/index.vue')), 'basin'),
              },
              {
                path: '/adTree',
                name: 'adTree',
                component: r => require.ensure([], () => r(require('../components/adTree.vue')), 'adTree'),
              },
              {
                path: '/adHistoryCharts',
                name: 'adHistoryCharts',
                component: r => require.ensure([], () => r(require('../components/itemcenter/commodityPool1688/adHistoryCharts.vue')), 'adHistoryCharts'),
              },
              {
                path: '/home/reviewPlanAdd',
                name: 'reviewPlanAdd',
                component: r => require.ensure([], () => r(require('../components/reviewPlanAdd.vue')), 'reviewPlanAdd'),
              },
              {
                path: '/home/reviewPlan',
                name: 'reviewPlan',
                component: r => require.ensure([], () => r(require('../components/reviewPlan.vue')), 'reviewPlan'),
              }
        ]
    },
    ]
})
